import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'

import Shortcut from './Profile.shortcut'
import Menu from './Profile.menu'

class Profile extends PureComponent {
    static propTypes = {
        hideLogout: PropTypes.bool,
        onClickChangeLanguage: PropTypes.func,
        onClickConfigureDevice: PropTypes.func,
        onClickLogout: PropTypes.func,
        onClickNavigateLog: PropTypes.func,
        onClickNavigateReports: PropTypes.func,
        onClickNavigateOperationsHub: PropTypes.func,
        username: PropTypes.string,
    }

    static defaultProps = {
        hideLogout: false,
        onClickChangeLanguage: () => null,
        onClickConfigureDevice: () => null,
        onClickLogout: () => null,
        onClickNavigateLog: () => null,
        onClickNavigateReports: () => null,
        onClickNavigateOperationsHub: () => null,
        username: null,
    }

    state = {
        isMenuOpen: false,
    }

    onClickShortcut = () => {
        const { isMenuOpen } = this.state
        this.setState({ isMenuOpen: !isMenuOpen })
    }

    buildOnClickEvent = (callback) => () => {
        this.setState({ isMenuOpen: false })
        callback()
    }

    render() {
        const { hideLogout, onClickChangeLanguage, onClickConfigureDevice, onClickLogout, onClickNavigateLog, onClickNavigateReports, onClickNavigateOperationsHub, username } = this.props
        const { isMenuOpen } = this.state
        return (
            <Fragment>
                <Shortcut active={isMenuOpen} onClick={this.onClickShortcut} />
                <Menu
                    hideLogout={hideLogout}
                    onBlur={this.onBlurMenu}
                    onClickChangeLanguage={this.buildOnClickEvent(onClickChangeLanguage)}
                    onClickConfigureDevice={this.buildOnClickEvent(onClickConfigureDevice)}
                    onClickLogout={this.buildOnClickEvent(onClickLogout)}
                    onClickNavigateLog={this.buildOnClickEvent(onClickNavigateLog)}
                    onClickNavigateReports={this.buildOnClickEvent(onClickNavigateReports)}
                    onClickNavigateOperationsHub={this.buildOnClickEvent(onClickNavigateOperationsHub)}
                    onClose={this.onClickShortcut}
                    open={isMenuOpen}
                    username={username}
                />
            </Fragment>
        )
    }
}

export default Profile
